export default __webpack_public_path__ + "static/media/GANESHA INDISCHES RESTAURANT OUTER DINE.92da0069.jpg";